import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "../supabaseClient";

export default function PaymentSuccess() {
  const navigate = useNavigate();
  const [message, setMessage] = useState("Verifying your payment and preparing your report...");

  useEffect(() => {
    const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

    const run = async () => {
      const params = new URLSearchParams(window.location.search);
      const assessmentId = params.get("assessment_id") || "";

      if (!assessmentId) {
        setMessage("Missing assessment id. Redirecting to dashboard...");
        setTimeout(() => navigate("/dashboard", { replace: true }), 1500);
        return;
      }

      const target = `/questionnaire?paid=true&assessment_id=${encodeURIComponent(assessmentId)}`;

      // ✅ wait for session restore a bit
      let session = null;

      for (let i = 0; i < 25; i++) {
        const { data } = await supabase.auth.getSession();
        session = data?.session;

        if (session?.user) break;
        await sleep(150);
      }

      // ✅ still no session → force login but RETURN to results after login
      if (!session?.user) {
        localStorage.setItem("redirect_after_login", target);
        navigate(`/login?return=${encodeURIComponent(target)}`, { replace: true });
        return;
      }

      const authUid = session.user.id;

      // ✅ store assessment id for this user
      localStorage.setItem(`current_assessment_id_${authUid}`, assessmentId);

      // ✅ poll backend for webhook/database confirmation
const apiBase = process.env.REACT_APP_API_BASE_URL || "";
      for (let attempt = 1; attempt <= 30; attempt++) {
        try {
          setMessage(`Payment confirmed. Finalizing your report... (${attempt}/30)`);

          const { data: sessionData } = await supabase.auth.getSession();
          const accessToken = sessionData?.session?.access_token;

          if (!accessToken) {
            throw new Error("Missing access token");
          }

          const res = await fetch(
            `${apiBase}/api/careerpivot/assessment-status/${assessmentId}`,
            {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${accessToken}`,
              },
            }
          );

          if (res.ok) {
            const status = await res.json();

            const isReady =
              status?.webhookProcessed === true ||
              status?.paymentStatus === "Paid";

            if (isReady) {
              localStorage.setItem(`dashboard_step_${authUid}`, "4");
              navigate(target, { replace: true });
              return;
            }
          } else if (res.status !== 404) {
            const text = await res.text();
            console.error("Assessment status check failed:", res.status, text);
          }
        } catch (err) {
          console.error("Payment verification polling error:", err);
        }

        await sleep(2000);
      }

      // ✅ fallback if webhook is slow
      setMessage("Payment received. Your report is taking a little longer to finalize. Redirecting...");

      setTimeout(() => {
        localStorage.setItem(`dashboard_step_${authUid}`, "4");
        navigate(target, { replace: true });
      }, 1500);
    };

    run();
  }, [navigate]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-[#0F0A24] text-white px-6 text-center">
      <h1 className="text-4xl text-green-400 font-bold mb-4">
        ✅ Payment Successful 🎉
      </h1>
      <p className="text-gray-300 text-lg max-w-xl">{message}</p>
    </div>
  );
}